import React from 'react';
import "./GuidedExperienceWizard.css";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetElsLookupsState } from '../../redux/reducers/getLookups/getElsLookupsReducer';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';
import { selectELSLookups } from '../../redux/selectors/exportSelectorPaths';
import { Option } from '../common/Dropdown/Dropdown';
import i18n from '../../i18n';

interface FloorWizardProps {
    updateWizardFunction : (value: number | null, name: string) => void;
    wizardNumber: Record<string, unknown>;
}

export default function FloorWizard(props: FloorWizardProps): JSX.Element {
    const { t } = useTranslation("guided_wizard");
    const elsLookupsState: GetElsLookupsState = useSelector(selectELSLookups);

    return (<div>
        <p>{t("floor-wizard.floor-description")}</p>
        <table className='wizard-table' role='presentation'>
            <thead>
                <tr>
                    <th className='small-column'>{t("unit-heading.floor-level")}</th>
                    <th>{t("unit-heading.number-of-units")}</th>
                </tr>
            </thead>
            <tbody>
                {(elsLookupsState.dropdowns.floorLevelOptions as Option[]).filter((floorLevelOption: Option) => floorLevelOption.value !== "").map((floorLevelOption, index) => (
                    <tr key={`floor-wizard-row-${index}`}>
                        <td><label htmlFor={`wizard-floor-${floorLevelOption.value}`}>{i18n.language === "fr" ? floorLevelOption.frenchText : floorLevelOption.text}</label></td>
                        <td>
                            <AIRPNumberInput 
                                initialValue={(props.wizardNumber[floorLevelOption.value as string]) as string}
                                negatives={false}
                                decimals={false}
                                name={`wizard-floor-${floorLevelOption.value}`}
                                max={999}
                                onChange={(value: number | null) => props.updateWizardFunction(value, `wizard-floor-${floorLevelOption.value}`)}/>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>)
}